// src/lib/media.js

export function normalizeMediaUrl(url) {

  if (!url) return "";

  // Already absolute URL
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  // If backend already returned /media/... just attach domain
  if (url.startsWith("/media")) {
    return `https://vartasocial.com${url}`;
  }

  // legacy uploads support
  if (url.startsWith("/uploads")) {
    return `https://vartasocial.com${url}`;
  }

  return url;
}